var map = {
	"./pwa-1.0/styles/choose-date.component.scss": "./template/pwa-1.0/styles/choose-date.component.scss",
	"./pwa-1.1/styles/choose-date.component.scss": "./template/pwa-1.1/styles/choose-date.component.scss"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./template sync recursive ^\\.\\/.*\\/styles\\/choose\\-date\\.component\\.scss$";